import { combineReducers } from 'redux';

// Import reducers here.
import userReducer from './userReducer';
import coursesReducer from './coursesReducer';
import everythingReducer from './everythingReducer';

const rootReducer = combineReducers({
	user: userReducer,
	courses: coursesReducer,
	everything: everythingReducer,
});

export default rootReducer;
